'use client';

import Select from '@alltrails/denali/components/Select';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import useLanguageSelect from '../../../hooks/useLanguageSelect';

type LanguageSelectDropdownProps = {
  languageRegionCode: LanguageRegionCode;
  enabledLanguages?: Array<string>;
  pageReloadOnLanguageChange?: boolean;
};

const defaultEnabledLanguages = ['de-DE', 'en-US', 'es-ES', 'fr-FR'];

const LanguageSelectDropdown = ({
  languageRegionCode,
  enabledLanguages = defaultEnabledLanguages,
  pageReloadOnLanguageChange
}: LanguageSelectDropdownProps) => {
  const { label, languages, selectedLanguage, selectLanguage } = useLanguageSelect({
    enabledLanguages,
    languageRegionCode,
    pageReloadOnLanguageChange
  });

  const options = languages.map(l => ({
    label: l.translatedLanguageName,
    value: l.languageRegionCode,
    dataTestId: l.translatedLanguageName
  }));

  return (
    <div id="language-button">
      <Select
        options={options}
        value={selectedLanguage}
        onChange={value => selectLanguage(value as LanguageRegionCode)}
        labelText={label}
        placeholder={label}
        size="sm"
        hideLabel
      />
    </div>
  );
};

export default LanguageSelectDropdown;
